
import { defineComponent } from "vue";
import KTUserMenu from "@/layout/header/partials/UserMenu.vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

export default defineComponent({
    name: "topbar",
    components: {
        KTUserMenu,
    },
    setup() {
        const i18n = useI18n();
        const setLocale = (locale) => {
            localStorage.locale = locale;
            i18n.locale.value = locale;
        };
        const getLocaleLang = () => {
            return localStorage.locale;
        };
        return {
            setLocale,
            getLocaleLang,
        };
    },
});
